import { render, staticRenderFns } from "./AgencyCreateDialog.vue?vue&type=template&id=0c572d24&scoped=true&"
import script from "./AgencyCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./AgencyCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyCreateDialog.vue?vue&type=style&index=0&id=0c572d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c572d24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCheckbox,VChip,VCol,VContainer,VForm,VRow,VSelect,VTextField,VTextarea})
